export enum MessageLevel {
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR"
}

export const messageTypeZh =
    {
        INFO: "信息",
        WARN: "警告",
        ERROR: "故障"
    }
